import {Fragment, ReactElement} from 'react'
import {withNamespaces, WithNamespaces, Trans} from 'react-i18next'
import {Typography, Grid, List, ListItem, ListItemText, Divider} from '@material-ui/core'
import messages from '../../../../../../../assets/messages'
import {formatDate} from '../../../../../../../common/utils'
import Amount from '../../../../../../Common/Amount'
import {TablePropsBase} from '../../types'
import {PaidPerformanceAmount} from '../PaidPerformanceAmount'
import {useStyles} from './styles'

const Component = (props: TablePropsBase & WithNamespaces): ReactElement => {
  const {lng, subscriptions, isDefaultDate, children} = props

  const classes = useStyles()

  return (
    <List classes={{root: classes.container}}>
      {subscriptions.map(subscription => {
        const {
          id,
          followerFullName,
          startedAt,
          stoppedAt,
          profit,
          pendingPerformanceFee,
          currency
        } = subscription

        return (
          <Fragment key={id}>
            <ListItem dense classes={{root: classes.listItem}}>
              <ListItemText classes={{root: classes.listItem}}>
                <Grid container justifyContent="space-between" direction="row">
                  <Grid item>
                    <Typography variant="caption">
                      <Trans {...messages.clientName} />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      {followerFullName ?? '-'}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" direction="row">
                  <Grid item>
                    <Typography variant="caption">
                      <Trans {...messages.startCopyingDate} />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      {startedAt != null ? formatDate(lng, startedAt) : '-'}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" direction="row">
                  <Grid item>
                    <Typography variant="caption">
                      <Trans {...messages.profitPerPeriod} />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      <Amount value={profit} currency={currency} locale='en-US' />
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" direction="row">
                  <Grid item>
                    <Typography variant="caption">
                      <Trans {...messages.stopCopyingDate} />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      {stoppedAt != null ? formatDate(lng, stoppedAt) : <Trans {...messages.copying} />}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" direction="row">
                  <Grid item>
                    <Typography variant="caption">
                      <Trans {...messages.performanceFeePaid} />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      <PaidPerformanceAmount subscription={subscription} isDefaultDate={isDefaultDate} />
                    </Typography>
                  </Grid>
                </Grid>
                {isDefaultDate ? (
                  <Grid container justifyContent="space-between" direction="row">
                    <Grid item>
                      <Typography variant="caption">
                        <Trans {...messages.performanceFee} />
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1">
                        <Amount
                          value={pendingPerformanceFee}
                          currency={currency}
                          locale='en-US'
                          classes={{root: classes.yellowText}}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                ) : null}
              </ListItemText>
            </ListItem>
            <Divider />
          </Fragment>
        )
      })}
      <ListItem classes={{root: classes.listPaginationItem}}>
        {children}
      </ListItem>
    </List>
  )
}

export const TableMobile = withNamespaces()(Component)
